import { Building2, CalendarClock, CalendarRange, MapPin, Users } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const workforceNav: NavEntry[] = [
  { label: 'Workers', icon: Users, path: '/workers', permission: 'workforce:read', order: 30 },
  { label: 'Attendance', icon: CalendarClock, path: '/attendance', permission: 'attendance:read', order: 31 },
  { label: 'Shift schedule', icon: CalendarRange, path: '/roster', permission: 'roster:read_all', order: 32 },
  { label: 'Locations', icon: MapPin, path: '/locations', permission: 'workforce:read', order: 33 },
  { label: 'Organization', icon: Building2, path: '/organization', permission: 'workforce:manage', order: 34 },
]
